"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALERT_MESSAGE = void 0;
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var abstract_component_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/abstract_component_store"));
var sns_button_list_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/sns_button_list_store"));
var hidden_form_input_list_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/hidden_form_input_list_store"));
var alert_store_1 = __importDefault(require("@hikakaku/shared/stores/estimate_form/common/alert_store"));
var google_analytics_manager_1 = __importDefault(require("@hikakaku/shared/util/google_analytics_manager"));
var input_store_factory_1 = require("@hikakaku/shared/stores/estimate_form/common/input/input_store_factory");
var telephone_estimatable_store_ranking_modal_store_1 = __importStar(require("@hikakaku/shared/stores/estimate_form/telephone_estimatable_store_ranking_modal_store"));
exports.ALERT_MESSAGE = '必須項目を入力してください';
var WATCH_POST_URL = '/estimate_form/watch/thanks';
var WATCH_URL = /^\/(estimate_form\/watch|lp\/watch(\/(rolex\/c3|seiko|omega)?)?)$/;
var INPUT_COMPLETE_GA_EVENT_ENABLED_INPUT_TYPES = [
    input_store_factory_1.InputType.EMAIL,
    input_store_factory_1.InputType.NUMBER,
    input_store_factory_1.InputType.SELECT,
    input_store_factory_1.InputType.TEL,
    input_store_factory_1.InputType.TEXT,
    input_store_factory_1.InputType.TEXTAREA,
    input_store_factory_1.InputType.RADIO,
    input_store_factory_1.InputType.CHECKBOX
];
var AbstractContainerStore = /** @class */ (function (_super) {
    __extends(AbstractContainerStore, _super);
    function AbstractContainerStore(props) {
        var _this = _super.call(this) || this;
        _this.formRef = react_1.default.createRef();
        _this.pageStores = [];
        _this.currentPage = 0;
        _this.isLoading = false;
        _this.isSending = false;
        _this.isModalOpen = false;
        _this.handleClickNextPageButton = function () {
            _this.currentPage = Math.min(_this.currentPage + 1, _this.pageStores.length - 1);
        };
        _this.handleClickPrevPageButton = function () {
            _this.currentPage = Math.max(_this.currentPage - 1, 0);
        };
        // Modal methods
        _this.handleModalButtonCLick = function () {
            var _a;
            (_a = _this.modalOnClickButton) === null || _a === void 0 ? void 0 : _a.call(_this);
        };
        _this.handleModalClose = function () {
            _this.isModalOpen = false;
        };
        _this.showModal = function (onClickButton) {
            onClickButton && (_this.modalOnClickButton = onClickButton);
            _this.isModalOpen = true;
        };
        _this.handleClickSubmitButton = function (event) {
            var path = typeof window !== 'undefined' ? window.location.pathname.replace(/\/$/, '') : '';
            if (path.match(WATCH_URL)) {
                event.target.formAction = WATCH_POST_URL;
            }
            if (_this.isSending) {
                event.preventDefault();
            }
            else if (_this.validate()) {
                _this.isSending = true;
                _this.removeBeforeUnloadEvent();
            }
            else {
                event.preventDefault();
                _this.alertStore.alertText = exports.ALERT_MESSAGE;
                _this.formRef.current && _this.formRef.current.scrollIntoView(true);
                _this.gaEventCategory && google_analytics_manager_1.default.postGAEvent(_this.gaEventCategory, 'error', '個人情報入力エラー');
            }
        };
        _this.handleClickSnsLoginButton = function () {
            if (typeof window !== 'undefined') {
                var path = window.location.pathname + window.location.search;
                document.cookie = "redirect_path_before_oauth=".concat(encodeURIComponent(path), "; path=/; max-age=600");
            }
            _this.saveDraft();
            _this.removeBeforeUnloadEvent();
        };
        _this.removeBeforeUnloadEvent = function () {
            window.removeEventListener('beforeunload', _this.handleBeforeUnload, false);
        };
        _this.assignInputCompleteGAEvent = function (props) {
            return props.map(function (props) { return (INPUT_COMPLETE_GA_EVENT_ENABLED_INPUT_TYPES.includes(props.type)
                ? (__assign(__assign({}, props), { onBlur: function (value) {
                        if (value && _this.gaEventCategory) {
                            google_analytics_manager_1.default.postGAEvent(_this.gaEventCategory, props.necessary ? 'input' : 'input_free', props.label);
                        }
                    } })) : (props)); });
        };
        _this.assignDropzoneGAEvent = function (props) {
            return props.map(function (props) { return (props.type === input_store_factory_1.InputType.PHOTOS
                ? (__assign(__assign({}, props), { onChangeDropzone: function (value) {
                        if (value && _this.gaEventCategory) {
                            google_analytics_manager_1.default.postGAEvent(_this.gaEventCategory, 'click', '画像アップロード');
                        }
                    } })) : (props)); });
        };
        _this.handleChangePage = function () {
            _this.pageStores.forEach(function (store, idx) {
                store.isActive = _this.currentPage === idx;
            });
            _this.formRef.current && _this.formRef.current.scrollIntoView(true);
        };
        _this.handleBeforeUnload = function (event) {
            _this.saveDraft();
            if (_this.props.noAlert) {
                return;
            }
            event.returnValue = '';
        };
        (0, mobx_1.reaction)(function () { return _this.pageStores; }, _this.handleChangePage);
        (0, mobx_1.reaction)(function () { return _this.currentPage; }, _this.handleChangePage);
        _this.props = props;
        _this.alertStore = new alert_store_1.default({ text: props.alertMessage || undefined });
        _this.hiddenFieldInputListStore = new hidden_form_input_list_store_1.default({});
        _this.snsButtonListStore = new sns_button_list_store_1.default({
            enabled: !props.isUserSignedIn && !props.noSnsButton,
            authenticityToken: props.authenticityToken,
            googleOAuthPathBase: props.googleOauthPathBase,
            lineOAuthPathBase: props.lineOauthPathBase,
            onClickButton: _this.handleClickSnsLoginButton
        });
        _this.gaEventCategory = props.gaEventCategory || undefined;
        _this.kaitoriBonusCampaignId = props.kaitoriBonusCampaignId;
        _this.abTestFormsVariant = props.abTestFormsVariant;
        if (props.kaitoriBonusCampaignId) {
            _this.hiddenFieldInputListStore.addHiddenField({
                name: 'estimate_form[kaitori_bonus_campaign_id]',
                value: String(props.kaitoriBonusCampaignId)
            });
        }
        _this.currentPage = props.pageNumber - 1;
        _this.fixedComponentStores = [_this.hiddenFieldInputListStore];
        if (typeof window !== 'undefined') {
            window.addEventListener('beforeunload', _this.handleBeforeUnload, false);
        }
        if (props.telephoneEstimatableStoreRanking.length > 0) {
            _this.telephoneEstimatableStoreRankingStore = new telephone_estimatable_store_ranking_modal_store_1.default({ rankingStores: props.telephoneEstimatableStoreRanking, lineAddFriendGaEventLabel: props.lineAddFriendGaEventLabel });
            _this.fixedComponentStores.push(_this.telephoneEstimatableStoreRankingStore);
            if (typeof window !== 'undefined') {
                // こいつがないとこのページを離れるで離れられない
                window.history.replaceState(telephone_estimatable_store_ranking_modal_store_1.DUMMY_HISTORY_STATE, '', null);
                // こいつがないとChromeに対策されてるのでpopstateイベントが発火しない
                window.history.pushState(null, '', null);
                window.addEventListener('popstate', _this.telephoneEstimatableStoreRankingStore.handlePopState, false);
            }
        }
        return _this;
    }
    AbstractContainerStore.prototype.assignInputGAEvent = function (props) {
        return this.assignInputCompleteGAEvent(this.assignDropzoneGAEvent(props));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "formRef", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], AbstractContainerStore.prototype, "fixedComponentStores", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], AbstractContainerStore.prototype, "pageStores", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "currentPage", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "isLoading", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "isSending", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "isModalOpen", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], AbstractContainerStore.prototype, "gaEventCategory", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "kaitoriBonusCampaignId", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", String)
    ], AbstractContainerStore.prototype, "abTestFormsVariant", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "handleClickNextPageButton", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "handleClickPrevPageButton", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "handleModalButtonCLick", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "handleModalClose", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "showModal", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AbstractContainerStore.prototype, "handleChangePage", void 0);
    return AbstractContainerStore;
}(abstract_component_store_1.default));
exports.default = AbstractContainerStore;
